import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Loader from "../global/Loader";

const User = () => {

    return (
        <Suspense fallback={<Loader />}>
            <Outlet />
        </Suspense>
    )
}
export default User;